(function () {
    'use strict';

    angular
        .module('app.notes')
        .factory('notesDataService', notesDataService);

    notesDataService.$inject = ['dataservice', 'common', 'attachmentService', '$timeout'];
    /* @ngInject */
    function notesDataService(dataservice, common, attachmentService, $timeout) {
        var $q = common.$q;
        var _originalNote;
        var service = {
            updateNote: updateNote,
            newNote: newNote,
            deleteNote: deleteNote,
            acknowledgeNote: acknowledgeNote,
            editNote: editNote,
            cancelEdit: cancelEdit,
            deleteAttachment: deleteAttachment,
            canEdit: canEdit,
            canDelete: canDelete
        };

        return service;

        function canEdit(n) {
            return n.CreatedById == common.userService.userId();
        }

        function canDelete(n) {
            return canEdit(n) || common.userService.userType() > 0;
        }

        function editNote(n) {
            _originalNote = angular.copy(n);
        }

        function cancelEdit(n) {
            n.Notes = _originalNote.Notes;
        }

        function updateNote(note, item) {
            var noteDto = {};
            noteDto.ID = note.ID;
            noteDto.BookingId = item.BookingId;
            noteDto.TaskId = item.TaskId;
            noteDto.Notes = note.Notes;

            dataservice.saveItem('api/DailySetup/UpdateNote', noteDto).then(function (saveResult) {
            }, function (error) { });
        }

        function deleteAttachment(id, n) {
            var atts = [];
            atts.push(id);
            attachmentService.remove(atts);

            n.FileName = "";
            n.Base64Data = "";
            n.StoredFile = null;
        }

        function deleteNote(note, item) {

            var id = note.ID;
            var routePart = item.TaskId > 0 ? "DeleteTaskNote" : "DeleteBookingNote";
            

            dataservice.deleteItem('api/DailySetup/' + routePart + '/' + id).then(function (saveResult) {
                $.each(item.Notes, function (index, result) {
                    if (result) {
                        if (result["ID"] == id) {
                            item.Notes.splice(index, 1);
                        }
                    }
                })
            }, function (error) { });
        }

        function acknowledgeNote(note, item) {
            dataservice.saveItem('api/DailySetup/AcknowledgeNote/' + note.ID).then(function (saveResult) {
            }, function (error) { });
        }

        function newNotePromise(note, item) {
            var p = new Promise(function (resolve, reject) {
                if (!note || !note.Notes || note.Notes.trim() === "") {
                    resolve(item);
                }

            });
            return p;
        }

        function newNote(note, item) {
            if (!(note.Notes) || note.Notes.trim() === "") {
                return null;
            }
            
            var noteDto = {};
            noteDto.BookingId = item.BookingId;
            noteDto.TaskId = item.TaskId;
            noteDto.Notes = note.Notes;
            noteDto.DepartmentId = note.DepartmentId >= 0 ? note.DepartmentId : null;
            noteDto.DisplayedOn = moment(common.getMainState("mainDate")).format("YYYYMMDD");

            var parentType = noteDto.TaskId > 0 ? "TaskNote" : "BookingNote";

            return dataservice.saveItem('api/DailySetup/NewNote', noteDto).then(function (saveResult) {
                var savedNote = saveResult.data;
                attachmentService.upload(parentType, savedNote.ID, savedNote).then(function (uploadResult) {
                    var id = savedNote.ID;

                    $.each(item.Notes, function (index, result) {
                        if (result) {

                            if (result["ID"] == id) {
                                item.Notes[index].FileName = savedNote.FileName;
                                item.Notes[index].Base64Data = savedNote.Base64Data;
                                item.Notes[index].StoredFile = savedNote.StoredFile;
                                item.Notes[index].HasAttachment = true;
                                item.Notes[index].AttachmentId = savedNote.AttachmentId;
                            }
                        }
                    });
                    
                });

                return savedNote;
                
            }).catch(function (error) {
            });
        }

    }
}());
